/**
 * Contact Us
 */
import React, { useEffect, useState } from 'react';
// import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
// import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
// import SVG from 'react-inlinesvg';
// import * as Sentry from '@sentry/browser';
// import * as Sentry from '@sentry/node';
// import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { Duration } from 'luxon';
import { GetStaticPaths, GetStaticProps } from 'next';
import FranchiseeGoogleMap from '../../components/FranchiseeGoogleMap';
import Head from '../../components/head';
import Layout from '../../components/Layout';
import OpenGraphDescription from '../../components/OpenGraphDescription';
import OpenGraphTitle from '../../components/OpenGraphTitle';
import PageTitle from '../../components/PageTitle';
import PhoneLink from '../../components/PhoneLink';
import Section from '../../components/Section';
// import TextColumns from '../../components/TextColumns';
import { FranchiseeProvider } from '../../context/Franchisee';
import { FranchiseeState } from '../../context/Franchisee/franchisee.types';
import Gataware from '../../SDKs/Gataware';

export const getStaticPaths: GetStaticPaths = async () => {
  const popularStores: Array<string> = ['fort-worth'];
  const paths = popularStores.map((storeSlug) => ({
    params: { franchiseeSlug: storeSlug },
  }));

  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { franchiseeSlug } = params;

  const response = await Gataware.getLocations({
    slugs: [franchiseeSlug.toLocaleString()],
  }).then(({ data }) => JSON.parse(data));

  const franchisees = await response.data
    .filter(({ slug }) => franchiseeSlug === slug)
    .map((franchisee) => camelcaseKeys(franchisee));

  if (!franchisees.length) {
    return {
      notFound: true,
    };
  }

  const [franchisee] = franchisees;

  return {
    props: {
      franchisee,
    },
    revalidate: Duration.fromObject({ hours: 8 }).as('seconds'),
  };
};

interface ContactPageProps {
  franchisee: FranchiseeState;
}

const Contact: React.FC<ContactPageProps> = ({
  franchisee,
}: ContactPageProps) => {
  const {
    phonePrimary,
    addressLineOne,
    addressLineTwo,
    city,
    state,
    zipCode,
    cities,
    name,
  } = franchisee;

  const communities = cities.split(';');
  return (
    <FranchiseeProvider franchiseeValue={franchisee}>
        <Layout alternateFooter>
          <Head
            slug='contact'
            title={`Contact | Two Maids | ${name}`}
            description={`Contact Two Maids ${name} to see why Two Maids is a Maid
          Service worth talking about!`}
          />
          <OpenGraphTitle title={`Contact | Two Maids | ${name}`} />
          <OpenGraphDescription>
            {`Contact Two Maids ${name} to see why Two Maids is a Maid Service worth talking about!`}
          </OpenGraphDescription>
          <div className='top-background-dots'></div>

          <Section padding='top' className='contact-us-title-container'>
            <PageTitle className='mb-5'>Contact Us</PageTitle>
          </Section>
          <Section padding='none' className='contact-us-content-container'>
            <h2 className='contact-page-city-state'>{city}, {state}</h2>
            <hr style={{background: 'var(--dark-pink' }} />
            <Row className='justify-content-between'>
              <Col
                xs={12}
                lg={6}
                className='order-md-0 text-md-left'
                >
                <p className='mb-3'>
                  {addressLineOne}
                  <br />
                  {addressLineTwo && (
                    <>
                      {addressLineTwo}
                      <br />
                    </>
                  )}
                  {city}, {state} {zipCode}
                  <br />
                  <PhoneLink number={phonePrimary} />
                </p>
                {communities[0] !== '' && (
                  <p>
                    We serve the following areas:
                  </p>
                )}
                <div className='mb-5 mb-md-0 communities-grid'>
                  {communities.map((community, index) => (
                    <div key={index}>
                      <span className='served-community'>
                       {community.trim()}
                      </span>
                      <br />
                    </div>
                  ))}
                </div>
              </Col>

              <Col xs={12} lg={6} className='order-0 order-md-1 mb-5'>
                <FranchiseeGoogleMap
                  style={{ width: '100%', height: '280px' }}
                  zoomLevel={9}
                  className='contact-page-google-map'
                />
              </Col>
            </Row>
          </Section>
        </Layout>
    </FranchiseeProvider>
  );
};

export default Contact;
